import { useController } from "react-hook-form";
import { setNumberValueAs } from "../../../../../../../../utils/react-hook-form";
import { FlexRow } from "../../../../../../../Common/__styles__/Layout";
import { Text } from "../../../../../../../Inputs/react-hook-form";
import {
  getSchemaPropertyFormPath,
  useBuilderFormContext,
} from "../../../form/form";
import type { InputSettingsFormProps } from "../FieldSettingsView";

export function MinMaxInputs({
  fieldPath,
  isReadOnly,
}: Omit<InputSettingsFormProps, "inputType" | "isModuleInput">) {
  const { register } = useBuilderFormContext();

  const minPropertyFormPath = getSchemaPropertyFormPath(fieldPath, "minimum");
  const maxPropertyFormPath = getSchemaPropertyFormPath(fieldPath, "maximum");

  const minValueControl = useController({ name: minPropertyFormPath });
  const maxValueControl = useController({ name: maxPropertyFormPath });

  return (
    <FlexRow gap="m">
      <Text
        {...register(minPropertyFormPath, {
          setValueAs: setNumberValueAs,
          deps: [maxPropertyFormPath],
        })}
        label="Number minimum"
        type="number"
        error={minValueControl.fieldState.error?.message}
        disabled={isReadOnly}
        data-testid="number-minimum-input"
      />
      <Text
        {...register(maxPropertyFormPath, {
          setValueAs: setNumberValueAs,
          deps: [minPropertyFormPath],
        })}
        label="Number maximum"
        type="number"
        error={maxValueControl.fieldState.error?.message}
        disabled={isReadOnly}
        data-testid="number-maximum-input"
      />
    </FlexRow>
  );
}
